<template>
<div class="">
<!--
   <div class="yo-fixed-top el-container" style="top:212px;">
        <div class="row yo-bg-color-primary" style="">
            <div class="col s6 yo-bg-color-primary"><el-input class="no-border" :placeholder="'Cerca il paziente'" prefix-icon="el-icon-search" v-model="$centro.pazienteCerca" style="none"> </el-input></div>
            <div class="col s6 yo-bg-color-primary white yo-text-n " style="padding:12px 0 12px 12px;" v-if="numitems>0">Trovati {{numitems}} contatti<span v-if="numitems>100">, vengono visualizzati solo i primi 100 pazienti</span> {{$centro.pazienteCerca}}</div>
            <div class="col s6 yo-bg-color-primary white yo-text-n " style="padding:12px 0 12px 12px;" v-if="numitems<1">Nessun centro trovato</div>
        </div>
    </div>
-->
    
    <div style="padding-top:54px;">
        <!-- TIPO: {{tipo}}<br />TOPIC: {{topic}}<br />ABSTRACT: {{$abstracts.data.length}} -->
		  <el-collapse accordion>

        <elCerca v-for="(item,index) in filtrati" :item="item" :numero="index+1" v-bind:key="item.id"></elCerca> 

		  </el-collapse>
    </div>


</div>
</template>

<script>
import elCerca from './Centro-elenco.vue'
export default {
   components: {
      elCerca
   }
   ,name: 'Cerca'
   ,data () {
      return {
         numitems: 0
      }
   },
  created () {
      this.$teras.event.on('variabile-saved', () => {
        //this.$axios.query('fetchAll',`SELECT * FROM variabile WHERE 1 ORDER BY nome`,{},this.$teras,'_contatto')

      })
  }
   ,methods:{
      variabileNew(){
         this.$router.push('/domanda-edit')
      }
   }
   ,computed: {
      filtrati: function () {
      this.numitems = this.$teras._centro.length

      console.log("TROVATI "+this.numitems+" PAZIENTI ora filtro per: "+this.$centro.pazienteCerca)
      
      if(this.numitems==0)
         return {}

      if(this.$centro.pazienteCerca=='' )
           return this.$teras._centro.slice(0, 200)
	 /*
		var words = this.$centro.pazienteCerca.toString().split('+')
		 
      
		var isFilter = []
		
      for (let item of this.$teras._centro){
			var trovati = 0
			for (let word of words){
				if(
            item.nome.toString().toLowerCase().indexOf(word.toLowerCase()) > -1 
            || 
            item.cognome.toString().toLowerCase().indexOf(word.toLowerCase()) > -1 
            || 
            item.ncartellaclinica.toString().toLowerCase().indexOf(word.toLowerCase()) > -1
            ) 
				trovati++
			}

			if(trovati==words.length)
				isFilter.push(item)


      }
      this.numitems = isFilter.length

*/         



      return (isFilter.length>200) ? isFilter.slice(0, 200) : isFilter
      
      }
   }
}

    
</script>

